import React, { useState } from 'react';
import "./assets/Header.css";
import wbcLogo from './assets/wbc_portal_simple_logo.svg';
import { signOut as cognitoSignOut } from '../cognito-auth';
import { handleLogout as azureLogout } from '../auth';


function UserDropdown({ userName, userEmail, onLogout }) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const closeTimeoutRef = React.useRef(null);

    const handleMouseEnter = () => {
        if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
        setIsDropdownOpen(true);
    };

    const handleMouseLeave = () => {
        closeTimeoutRef.current = setTimeout(() => setIsDropdownOpen(false), 150);
    };

    const handleLogoutClick = () => {
        try { cognitoSignOut(); } catch (e) {}
        try { azureLogout(); } catch (e) {}
        if (onLogout) { onLogout(); } else { window.location.reload(); }
    };

    const initials = (userName || userEmail || '?')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(w => w[0].toUpperCase())
        .join('');

    return (
        <div className="user-dropdown" onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
            <div className="user-avatar" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                <span className="user-avatar-dot" />
                <span className="user-avatar-name">{userName || userEmail}</span>
                <span className="user-avatar-initials">{initials}</span>
            </div>

            {isDropdownOpen && (
                <div className="user-dropdown-content">
                    <div className="user-dropdown-header">
                        <div className="user-dropdown-name">{userName}</div>
                        <div className="user-dropdown-email">{userEmail}</div>
                    </div>
                    <div className="user-dropdown-item logout-item" onClick={handleLogoutClick}>
                        <span className="logout-icon">↻</span>
                        Logout
                    </div>
                </div>
            )}
        </div>
    );
}

function Header({ selectedTab, setSelectedTab, userName, userEmail, allowedTabs, isAuthenticated, isLoadingTabs, authStatus, onLogout }) {
    // Helper function to map display names to internal names for permission checking
    const getInternalTabName = (displayName) => {
        if (displayName === "AI Insights") return "Insights";
        // The old "Diagnostics" tab is retired (hidden from nav). The "Diagnostics"
        // chip now opens the new tab, whose internal key remains "New Diagnostics".
        if (displayName === "Diagnostics") return "New Diagnostics";
        return displayName;
    };

    const menuItems = {
        "Home": [],
        "Overview": [],
        "Analytics": [],
        "Diagnostics": [],
        "Real Time": [],
        "Config Management": [],
        "Device Recovery": [],
        "License Hub": [],
        "Utilities": [],
        "AI": [],
        "Reports": [],
    };

    // Filter menuItems based on allowedTabs - only show tabs if authenticated and authorized
    const filteredMenuItems = {};

    if (isAuthenticated && !isLoadingTabs && allowedTabs.length > 0) {
        Object.keys(menuItems).forEach((menu) => {
            const internalName = getInternalTabName(menu);
            const filteredSubItems = menuItems[menu].filter(item => allowedTabs.includes(`${internalName}/${item}`));
            if (filteredSubItems.length > 0 || allowedTabs.includes(internalName)) {
                filteredMenuItems[menu] = filteredSubItems;
            }
        });
    }

    return (
        <header className="app-header">
            <div className="app-header-inner">
            <div className="logo" onClick={() => setSelectedTab("Overview")}>
                <img src={wbcLogo} alt="WBC Portal" className="logo-img" />
            </div>

            <div className="header-divider"></div>

            <nav className="domain-nav">
                {Object.keys(filteredMenuItems).map((menu) => (
                    filteredMenuItems[menu].length > 0 ? (
                        <div className="nav-dropdown" key={menu}>
                            <span className={`nav-item ${selectedTab.startsWith(menu) ? 'active' : ''}`}>{menu}</span>
                            <div className="dropdown-content">
                                {filteredMenuItems[menu].map((item) => (
                                    <div
                                        key={item}
                                        className="dropdown-item"
                                        onClick={() => setSelectedTab(`${menu}/${item}`)}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <span
                            key={menu}
                            className={`nav-item ${selectedTab === getInternalTabName(menu) ? 'active' : ''}`}
                            onClick={() => setSelectedTab(getInternalTabName(menu))}
                        >
                            {menu}
                        </span>
                    )
                ))}
            </nav>

            <div className="header-right">
                {isAuthenticated ? (
                    <UserDropdown userName={userName} userEmail={userEmail} onLogout={onLogout} />
                ) : null}
            </div>
            </div>
        </header>
    );
}

export default Header;
